const translations = {
  en: {
    "header.react.link_0": "Applications",
    "header.react.link_1": "Settings",
    "header.react.link_3": "Contact Support",
    "header.react.link_4": "Logout",
    "header.react.link_5": "Migrate!",
    "header.react.link_6": "APIs",
    "header.react.link_7": "Guides",
    "header.react.link_8": "Account",

    "applications.title": "Applications",
    "applications.add": "Add Application",
    "applications.add.success":
      "Successfully created API credential: {appName} ",
    "applications.error": "Something went wrong :( try refreshing browser.",
    "applications.credentials.heading": "API Credentials",
    "applications.credentials.empty_heading": "Create OAuth 2.0 Credentials",
    "applications.credentials.empty_body":
      "Click 'Create API Credential' to get started.",
    "applications.form.cancel": "Cancel",
    "applications.form.name": "Name",
    "applications.form.scope": "Token Scope (sid)",
    "applications.form.client_id": "Client ID",
    "applications.form.client_secret": "Client Secret",
    "applications.form.create.title": "Create API Credential",
    "applications.form.create.submit": "Create",
    "applications.form.delete.title": "Delete API Credential",
    "applications.form.delete.body":
      "After deletion the applications or services using that API credential are going to stop working.",
    "applications.form.delete.submit": "Delete",
    "applications.form.delete.submit.sucess":
      "Successfully deleted API credential {appName}",
    "applications.form.edit.title": "Edit API Credential",
    "applications.form.edit.body":
      "After deletion the applications or services using that API credential are going to stop working.",
    "applications.form.edit.submit": "Delete",
    "applications.form.edit.save": "Save",
    "applications.form.edit.success":
      "Successfully edited API credential for {appName}",
    "applications.form.error": "Error: Internal call to Kong API failed",
    "applications.form.error.unique": "App name must be unique",
    "applications.form.error.size": "App name must be at least 3 characters",
    "applications.form.error.scope":
      "Scope must be a numerical publisher sid tied to account",
    "applications.form.error.sid": "Invalid SID",
    "applications.form.error.rate": "Rate limit exceeded",
    "applications.form.token.title": "Generate API Access Token",
    "applications.form.token.submit": "Generate Token",
    "applications.form.migrate.sucess":
      "Success! Migrated previous API Credentials to new account",
    "applications.form.token.success":
      "Access Token successfully generated for {app}:  {token}",
    "applications.table.header.name": "Name",
    "applications.table.header.client_id": "Client ID",
    "applications.table.header.client_secret": "Client Secret",
    "applications.table.header.actions": "Actions",
    "applications.table.button.token": "Generate Token",
    "applications.table.button.edit": "Edit",
    "applications.table.button.delete": "Delete",

    "settings.title": "Account Information",
    "settings.error": "Something went wrong :( try refreshing browser.",
    "settings.user.email": "Email",
    "settings.user.migration_date": "User completed migration",
    "settings.user.history.title": "User History",

    "migrate.title": "Migrate Legacy Applications",
    "migrate.note": "Note:",
    "migrate.link": "カスタマー サービス",
    "migrate.callout": "Migrate",
    "migrate.complete": "Complete Migration",
    "migrate.agreement":
      "I have read the notice above, updated my API URLs, and I am ready to proceed to Step 3",
    "migrate.error": "Something went wrong :( try refreshing browser.",
    "migrate.body_0":
      "Welcome to the new Rakuten Advertising developer portal! Before you begin using the new portal, we recommend that all accounts migrate their legacy applications (client ID and client secret) into the new portal to avoid disruptions to current processes.",
    "migrate.body_1":
      "If you have any questions about the process, feel free to reach out to ",
    "migrate.body_1_link": "customer support",
    "migrate.stepone.heading": "Step 1: Migrate Legacy Applications",
    "migrate.stepone.body_0":
      "By clicking on 'Migrate', any existing applications detected in your legacy account will be imported into this account.",
    "migrate.stepone.body_1":
      "You can check the 'Applications' tab to confirm that your legacy applications have been migrated over.",
    "migrate.stepone.note_body_0":
      " This step will not affect any API processes already in place; all APIs should be working as expected.",
    "migrate.stepone.note_body_1":
      "If you have zero (0) applications to migrate, you may proceed to Step 3 to complete the migration.",
    "migrate.steptwo.heading":
      "Step 2: Update your URL to 'api.linksynergy.com'",
    "migrate.steptwo.body_0":
      "After confirming that your applications have migrated successfully, all API URLs in your system need to be updated from 'api.rakutenmarketing.com' to 'api.linksynergy.com'.",
    "migrate.steptwo.listtitle":
      "This update only applies to the following APIs:",
    "migrate.steptwo.listitem_0": "Tokens API (/token)",
    "migrate.steptwo.listitem_1": "Advanced Reports API (/advancedreports/1.0)",
    "migrate.steptwo.listitem_2":
      "Advertiser Search API (/advertisersearch/1.0)",
    "migrate.steptwo.listitem_3": "Coupon Feed API (/coupon/1.0)",
    "migrate.steptwo.listitem_4": "Events API (/events/1.0/transactions)",
    "migrate.steptwo.listitem_5": "Link Locator API (/linklocator/1.0)",
    "migrate.steptwo.listitem_6": "Product Search API (/productsearch/1.0)",
    "migrate.steptwo.note_body_0":
      " This step is completed outside of the portal. The update is required for all existing processes currently utilizing Rakuten’s APIs on the publisher’s side.",
    "migrate.steptwo.note_body_1":
      "Please check the box below indicating you have taken the necessary steps to ensure all API URLs in your system have been updated.",
    "migrate.stepthree.heading": "Step 3: Inform Us!",
    "migrate.stepthree.body_0":
      "Once you’ve completed Steps 1 and 2, and have confirmed that all API calls are returning a 200 response, let us know by clicking'“Complete Migration'.",
    "migrate.stepthree.note_body_0":
      " As soon as you click 'Complete Migration', this page will no longer show up in your dropdown.",
    "migrate.apps.done": "Legacy applications have been previously migrated",
    "migrate.apps.none": "No legacy applications found",
    "migrate.apps.total": "Total",
    "migrate.apps.heading": "Legacy Applications",
    "migrate.apps.incomplete": "Your migration is not yet complete",
    "migrate.apps.complete": "Migration is completed",
  },
  ja: {
    "header.react.link_0": "アプリケーション",
    "header.react.link_1": "設定",
    "header.react.link_3": "フィードバックの送信",
    "header.react.link_4": "ログアウト",
    "header.react.link_5": "移行",
    "header.react.link_6": "APIs",
    "header.react.link_7": "ガイド",
    "header.react.link_8": "アカウント",

    "applications.title": "アプリケーション",
    "applications.add": "アプリケーションを追加",
    "applications.add.success": "アプリケーションが追加されました: {appName}",
    "applications.error":
      "何らかの問題が発生しました :( ブラウザを更新してみてください。",
    "applications.credentials.heading": "API 認証情報",
    "applications.credentials.empty_heading": "OAuth 2.0 証明書を作成",
    "applications.credentials.empty_body":
      "[API 証明書の作成] をクリックして開始します。",
    "applications.form.cancel": "キャンセル",
    "applications.form.name": "名前",
    "applications.form.scope": "トークン スコープ (sid)",
    "applications.form.client_id": "クライアント ID",
    "applications.form.client_secret": "クライアント シークレット",
    "applications.form.create.title": "API 認証情報を作成",
    "applications.form.create.submit": "作成",
    "applications.form.delete.title": "API 認証情報を削除",
    "applications.form.delete.body":
      "削除後、その API 認証情報を使用するアプリケーションまたはサービスは動作を停止します。",
    "applications.form.delete.submit": "削除",
    "applications.form.delete.submit.sucess":
      "アプリケーションを削除しました {appName}",
    "applications.form.edit.title": "API 認証情報の編集",
    "applications.form.edit.body":
      "削除後、その API 認証情報を使用するアプリケーションまたはサービスは動作を停止します。",
    "applications.form.edit.submit": "削除",
    "applications.form.edit.success":
      "アプリケーションを編集しました {appName}",
    "applications.form.edit.save": "貯める",
    "applications.form.error": "何らかの問題が発生しました",
    "applications.form.error.unique":
      "アプリケーション名が重複しています。別のアプリケーション名を登録してください",
    "applications.form.error.size":
      "アプリケーション名は3文字以上で入力してください",
    "applications.form.error.scope":
      "スコープは、アカウントに関連付けられた数値のパブリッシャーSIDである必要があります",
    "applications.form.token.title": "API アクセス トークンの生成",
    "applications.form.error.sid": "無効なSIDです",
    "applications.form.error.rate": "レート制限を超えました",
    "applications.form.token.success":
      "APIリクエスト用認証ヘッダー アプリケーション名: {app}:  {token}",
    "applications.form.token.submit": "トークンを生成",
    "applications.table.header.name": "名前",
    "applications.table.header.client_id": "クライアント ID",
    "applications.table.header.client_secret": "クライアント シークレット",
    "applications.table.header.actions": "アクション",
    "applications.table.button.token": "トークンを生成",
    "applications.table.button.edit": "編集",
    "applications.table.button.delete": "削除",

    "settings.title": "アカウント情報",
    "settings.error":
      "何らかの問題が発生しました :( ブラウザを更新してみてください。",
    "settings.user.email": "メールアドレス",
    "settings.user.migration_date": "旧アプリケーションからの移行完了",
    "settings.user.history.title": "履歴",

    "migrate.title": "旧アプリケーションの移行",
    "migrate.note": "注:",
    "migrate.link": "お問い合せフォーム",
    "migrate.callout": "移行",
    "migrate.complete": "移行の完了",
    "migrate.agreement": "上記の注意事項を確認し、APIの URLを更新完了",
    "migrate.error":
      "何らかの問題が発生しました。ページを更新し、再度お試しください。",
    "migrate.body_0":
      " APIディベロッパーポータルが新しくなりました。旧APIディベロッパーポータルをご利用いただいているアフィリエイトサイト様には既存のアプリケーション(Consumer Key, Consumer Secret)を新アプリケーションに移行いただくことをお勧めいたします。",
    "migrate.body_1":
      "移行手順についてご不明点がございましたらお気軽にお問い合わせ下さい。",
    "migrate.body_1_link": "お問い合せフォーム",
    "migrate.body_1_b": "よりお問い合わせください。",
    "migrate.stepone.heading": "ステップ 1: 旧アプリケーションの移行について",
    "migrate.stepone.body_0":
      "[移行] をクリックすると、旧APIを利用している既存のアプリケーションが表示されます。",
    "migrate.stepone.body_1":
      "[旧アプリケーション] にご利用のアプリケーション名が表示されます。",
    "migrate.stepone.note_body_0":
      "こちらのステップは現在ご利用の APIのレスポンスには影響しません。",
    "migrate.stepone.note_body_1":
      "移行するアプリケーションが表示されない場合は、手順 3 に進んで移行を完了することができます。",
    "migrate.steptwo.heading":
      "ステップ 2: URL を「api.linksynergy.com」に更新します",
    "migrate.steptwo.body_0":
      "アプリケーションが正常に移行したことを確認したら、ご利用のすべての API URL を「api.rakutenmarketing.com」から「api.linksynergy.com」に更新してください。",
    "migrate.steptwo.listtitle": "この更新は、次の API にのみ適用されます。",
    "migrate.steptwo.listitem_0": "トークン API (/token)",
    "migrate.steptwo.listitem_1": "詳細レポート API (/advancedreports/1.0)",
    "migrate.steptwo.listitem_2": "広告主検索 API (/advertisersearch/1.0)",
    "migrate.steptwo.listitem_3": "クーポン フィード API (/coupon/1.0)",
    "migrate.steptwo.listitem_4": "イベント API (/events/1.0/transactions)",
    "migrate.steptwo.listitem_5": "リンク ロケーター API (/linklocator/1.0)",
    "migrate.steptwo.listitem_6": "商品検索 API (/productsearch/1.0)",
    "migrate.steptwo.note_body_0":
      "このステップはご利用のAPI　URLを新URLに置き換えていただくことで完了します。",
    "migrate.steptwo.note_body_1":
      "全てのご利用API URLの更新が完了しましたら下記のチェックボックスにチェックを入れてください。",
    "migrate.stepthree.heading": "ステップ 3: 移行を完了してください",
    "migrate.stepthree.body_0":
      "ステップ 1 と 2 を完了し、すべての API のレスポンスが レスポンスコード：200を返却していることをご確認いただきましたら、[移行の完了] をクリックしてください。",
    "migrate.stepthree.note_body_0":
      "[移行の完了] をクリックするとこのページはドロップダウンに表示されなくなります。",
    "migrate.apps.done": "旧アプリケーションは移行が完了しております。",
    "migrate.apps.none": "移行するアプリケーションがありません",
    "migrate.apps.total": "計：",
    "migrate.apps.heading": "旧アプリケーション",
    "migrate.apps.incomplete": "現在の状況：移行が完了していません",
    "migrate.apps.complete": "旧アプリケーションは移行が完了しております。",
  },
};

export default translations;
